import { render, staticRenderFns } from "./ClipWaves.vue?vue&type=template&id=1cf29eac&scoped=true"
import script from "./ClipWaves.vue?vue&type=script&lang=js"
export * from "./ClipWaves.vue?vue&type=script&lang=js"
import style0 from "./ClipWaves.vue?vue&type=style&index=0&id=1cf29eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf29eac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
